const { map, property } = require('lodash'), recipeDtmMapper = require('../dtmmapper/recipe-analytics-mapper');

class RecipeDetailController {
    constructor($location, $state, $window, featureService, analyticsService, breakpointsService, trolleyService) {
        this.$location = $location;
        this.$state = $state;
        this.$window = $window;
        this.featureService = featureService;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
    }

    $onInit() {
        this.socialMediaEnabled = this.featureService.isEnabled(this.featureService.features.recipeSocialMedia);
        this.emailExportEnabled = this.featureService.isEnabled(this.featureService.features.recipeEmailExport);
        this.printExportEnabled = this.featureService.isEnabled(this.featureService.features.recipePrintExport);
        this.showSubheaderControls = this.socialMediaEnabled || this.emailExportEnabled || this.printExportEnabled;

        this.analyticsService.push({ data: { recipe: this.recipe }, dtmMapperFn: recipeDtmMapper });
    }

    // Ideally author information should be coming from the data layer.
    getRecipeAuthor() {
        return this.recipe && this.recipe.ParentCategoryName === 'jamie-oliver'
            ? 'Jamie Oliver'
            : 'Woolworths';
    }

    back(event) {
        event.preventDefault();
        this.$window.history.back();
    }

    addAllProductsToTrolley() {
        const products = map(this.recipe.Ingredients, property('Product'));
        this.trolleyService.addItemsToTrolley(products);
        this.analyticsService.pushEvent(this.analyticsService.eventsDtm.ADD_ALL);
    }
}

const recipeDetailComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: ['$location', '$state', '$window', 'FeatureService', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', RecipeDetailController],
    template: require('./recipe-detail.component.html').trim(),
};

module.exports = {
    RecipeDetailController,
    recipeDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail.component.js